var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.products),function(product,i){return [_c('product',{attrs:{"slug":product.slug,"motive":product.motive,"error-messages":product.errorMessages},nativeOn:{"click":function($event){return _vm.$emit('click', { product })}}}),(i + 1 < _vm.products.length)?_c('v-divider',{staticClass:"my-2"}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }